import React, { FC } from 'react';
import { Trans } from 'react-i18next';

import { RecommendContentComponent } from 'api';
import { QueryManager } from 'components';

import ContentWidget from './ContentWidget';

const ShareThese: FC = () => (
  <RecommendContentComponent variables={{ size: 4, results_from: 0 }}>
    {queryResult => (
      <QueryManager loader="none" {...queryResult}>
        {({ data }) => {
          if (!data || !data.recommendContent) {
            return null;
          }

          return (
            <ContentWidget
              results={data.recommendContent.results}
              title={<Trans i18nKey="sharing:shareThese" />}
            />
          );
        }}
      </QueryManager>
    )}
  </RecommendContentComponent>
);

export default ShareThese;
